// export const baseURL = "http://localhost:5000/api/";
export const baseURL = "https://backend.msiddiquesteel.com/api/";
// export const SocketURL = 'http://localhost:5000';
export const SocketURL = 'https://backend.msiddiquesteel.com/';
// 
// export const imageURL = "http://localhost:5000/";
export const imageURL = "https://backend.msiddiquesteel.com/api/";